module.exports = "/assets/data/d18a6a3726e255c0c9d827b980e59b3a-SG19.data.json";